import { forwardRef, type Ref, type SVGProps } from "react";
const IconHardHatOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 6a3 3 0 0 1 2.93 2.361l.454.133C23.979 9.966 26 14.56 26 20q0 .087-.003.173A2.998 2.998 0 0 1 25 26H7a3 3 0 0 1-.998-5.827L6 20c0-5.615 2.153-10.33 7.068-11.639q0 .008-.003.014A3 3 0 0 1 16 6M7 22a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2zm12-6-.004.154a3 3 0 0 1-5.992 0L13 16v-5.523q-.537.194-1.004.455.004.033.004.068v5a1 1 0 1 1-2 0v-3.318l-.023.03C8.697 14.425 8 16.95 8 20h16c0-3.05-.696-5.576-1.977-7.287L22 12.682V16a1 1 0 1 1-2 0v-5q0-.035.003-.068A7 7 0 0 0 19 10.477zm-3-8a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHardHatOutlineSVG);
ForwardRef.displayName = "IconHardHatOutline";
export { ForwardRef as IconHardHatOutline };
